<template>
  <div class="c_search_result">
    <a
      v-if="name && url"
      :href="url"
      class="c_search_result__title"
      v-html="name"
      :data-insights-index="indexName || null"
      :data-insights-object-id="objectId || null"
      :data-insights-position="typeof position === 'number' ? position : null"
      :data-insights-query-id="queryId || null"
      @click="handleClick"
    ></a>
    <a
      v-if="url"
      :href="url"
      class="c_search_result__anchor"
      :data-insights-index="indexName || null"
      :data-insights-object-id="objectId || null"
      :data-insights-position="typeof position === 'number' ? position : null"
      :data-insights-query-id="queryId || null"
      @click="handleClick"
      >{{ url }}</a
    >
    <p v-if="snippet" v-html="snippet"></p>
  </div>
</template>

<script>
import { defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'SearchResult',
  props: {
    name: { type: String, required: true },
    url: { type: String, required: true },
    displayUrl: { type: String, required: false },
    snippet: { type: String, required: true },
    objectId: { type: String, required: false },
    position: { type: Number, required: false },
    queryId: { type: String, required: false },
    indexName: { type: String, required: false },
    gtmClickDelayMs: { type: Number, required: false, default: 0 },
    gtmUseRouterNavigation: { type: Boolean, required: false, default: false },
  },
  methods: {
    isModifiedClick(evt) {
      return evt && (evt.metaKey || evt.ctrlKey || evt.shiftKey || evt.altKey || evt.button === 1);
    },
    isExternalUrl(href) {
      try {
        if (!href) return false;
        if (href.startsWith('/')) return false;
        const u = new URL(href, window.location.origin);
        return u.origin !== window.location.origin;
      } catch (_e) {
        return false;
      }
    },
    handleClick(evt) {
      this.$emit('result-click', {
        objectID: this.objectId || null,
        position: typeof this.position === 'number' ? this.position : null,
        queryID: this.queryId || null,
        index: this.indexName || null,
        url: this.url || null,
      });

      const delay = Number(this.gtmClickDelayMs) || 0;
      if (!delay) return;

      if (this.isModifiedClick(evt)) return;

      if (evt && typeof evt.preventDefault === 'function') evt.preventDefault();

      const href = this.url || '';
      const useRouter = !!this.gtmUseRouterNavigation && !this.isExternalUrl(href);

      window.setTimeout(() => {
        try {
          if (useRouter && this.$router) {
            const pathOnly = href.startsWith('http') ? new URL(href).pathname : href;
            this.$router.push({ path: pathOnly });
          } else if (href) {
            window.location.assign(href);
          }
        } catch (e) {
          if (href) window.location.assign(href);
        }
      }, delay);
    },
  },
});
</script>

<style lang="scss">
.c_search_result {
  $self: &;
  margin-top: px_to_rem(37);
  &:not(:last-of-type) {
    margin-bottom: px_to_rem(35);
  }
  @at-root #{&}__title {
    display: block;
    color: $color_black;
    font-size: px_to_rem(22);
    line-height: 1;
    margin-bottom: 1rem;
    text-decoration: none;
    @include mq($mq_grid_start) {
      margin-bottom: px_to_rem(7);
    }
  }
  @at-root #{&}__anchor {
    display: inline-block;
    @include fz(5, px_to_rem(14), 700);
    color: $color_red;
    line-height: 1;
    margin-bottom: 1rem;
    @include mq($mq_grid_start) {
      margin-bottom: px_to_rem(7);
    }
  }
  @at-root #{&}__snippet {
    @include fz(5, px_to_rem(14), 700);
    line-height: 1;
  }
  b {
    @include font('graphik_semibold');
    font-weight: bold;
  }
}
</style>
